import React, { useContext } from 'react'
import { styled } from '@mui/material/styles'
import MuiTypography from '@mui/material/Typography'
import { ThemeContext } from './ThemeContext'

const CssTypography = styled(MuiTypography)((props) => {
  const { theme, style, source } = props
  return source
    ? { ...theme?.typography, ...theme?.typography?.[source], ...style }
    : { ...theme?.typography, ...style }
})

const Typography = (props) => {
  const { children } = props
  const { theme } = useContext(ThemeContext)
  return (
    <CssTypography {...props} theme={theme}>
      {children}
    </CssTypography>
  )
}

export default Typography
